import { render, staticRenderFns } from "./TeachOverview.vue?vue&type=template&id=6a5b7c50&scoped=true"
import script from "./TeachOverview.vue?vue&type=script&lang=js"
export * from "./TeachOverview.vue?vue&type=script&lang=js"
import style0 from "./TeachOverview.vue?vue&type=style&index=0&id=6a5b7c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b7c50",
  null
  
)

export default component.exports